import Viewer from "./Viewer"
import Editor from "./Editor"

export default {
    name: "diagram",
    title: "Diagram",
    icon: require("./content-icon.svg"),
    category: "engineering",
    Viewer,
    Editor,
    Preview: Viewer
}